export default class NetworkPage {
    constructor(lenis) {
        this.lenis = lenis;
        this.flags = document.querySelectorAll(".no-network__flag");
        this.items = document.querySelectorAll(".no-network__item");
        this.mapContainer = document.querySelector(".no-network__map");
        this.mapImage = this.mapContainer?.querySelector("img");
        this.originalMapWidth = null; // 맵의 원래 너비 저장
        this.originalFlagSizes = new Map(); // 각 국기의 원래 크기 저장
        this.init();
    }

    init() {
        console.log("[NetworkPage] init()");
        this.bindEvents();
        this.storeOriginalSizes();
    }

    storeOriginalSizes() {
        // 맵 이미지의 원래 크기 저장

        if (this.mapImage) {
            if (this.mapImage.complete) {
                this.originalMapWidth = this.mapImage.naturalWidth;
                this.storeFlagSizes();
            } else {
                this.mapImage.addEventListener("load", () => {
                    this.originalMapWidth = this.mapImage.naturalWidth;
                    this.storeFlagSizes();
                });
            }
        }
    }

    storeFlagSizes() {
        let loadedCount = 0;
        const totalFlags = this.flags.length;

        // 각 국기의 원래 크기 저장
        this.flags.forEach((flag) => {
            const img = flag.querySelector("img");
            if (img) {
                if (img.complete) {
                    this.originalFlagSizes.set(flag, img.naturalWidth);
                    loadedCount++;
                    if (loadedCount === totalFlags) {
                        this.updateFlagSizes();
                    }
                } else {
                    img.addEventListener("load", () => {
                        this.originalFlagSizes.set(flag, img.naturalWidth);
                        loadedCount++;
                        if (loadedCount === totalFlags) {
                            this.updateFlagSizes();
                        }
                    });
                }
            }
        });
    }

    bindEvents() {
        this.flags.forEach((flag) => {
            flag.addEventListener("click", () => this.handleFlagClick(flag));
        });

        // 윈도우 리사이즈 시 국기 크기 업데이트
        let resizeTimer;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.updateFlagSizes();
            }, 150);
        });
    }

    updateFlagSizes() {
        if (!this.mapImage || !this.originalMapWidth) return;

        // 맵 이미지의 축소 비율 계산 (현재 크기 / 원래 크기)
        const currentMapWidth = this.mapImage.offsetWidth;
        const scaleRatio = currentMapWidth / this.originalMapWidth;

        // 각 국기의 원래 크기에 축소 비율을 적용
        this.flags.forEach((flag) => {
            const img = flag.querySelector("img");
            if (img && this.originalFlagSizes.has(flag)) {
                const originalFlagWidth = this.originalFlagSizes.get(flag);
                const newFlagWidth = originalFlagWidth * scaleRatio;
                img.style.width = `${newFlagWidth}px`;
            }
        });
    }

    handleFlagClick(flag) {
        const key = flag.getAttribute("data-key");
        const targetItem = document.querySelector(
            `.no-network__item[data-key="${key}"]`
        );

        if (!targetItem) {
            console.warn(`No item found with key: ${key}`);
            return;
        }

        // 기존 active 클래스 제거
        this.items.forEach((item) => item.classList.remove("active"));

        // 새로운 item에 active 클래스 추가
        targetItem.classList.add("active");

        // 화면 중앙에 오도록 offset 계산
        const itemRect = targetItem.getBoundingClientRect();
        const itemTop = itemRect.top + window.scrollY;
        const windowHeight = window.innerHeight;
        const itemHeight = itemRect.height;
        const offset = itemTop - windowHeight / 2 + itemHeight / 2;

        // Lenis를 사용한 스크롤
        if (this.lenis) {
            this.lenis.scrollTo(offset, {
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            });
        } else {
            // Lenis가 없는 경우 기본 스크롤
            window.scrollTo({
                top: offset,
                behavior: "smooth",
            });
        }
    }
}
